import "./Main.css";
import React from "react";
import Startbtn from "./Startbtn";
import AddButton from "./AddButton";
function Main() {
  return (
    <div className="Main">
      <div className="body">
        <div className="Maintitle">여기 </div>
        <div className="Maintitle">잠깐 </div>
        <div className="Maintitle">밥팟 </div>
      </div>

      <div className="start">
        <Startbtn title="시작하기"></Startbtn>
      </div>
    </div>
  );
}

export default Main;
